<template>
    <SubLayout
        :pageTitle="title"
        :pageBreadcrumbs="breadcrumbs"
        :hasBack="false"
    >
  
      <template #layoutContent>
        <ActionsBar :query="query" :handleRangeDate="handleRangeDate" :showSearch="route.query.viewType === modelViewType.calendar" :types="types" :status="appointmentStatus" id="appointments-datepicker"/>

        <List :filter="query" v-if="route.query.viewType === modelViewType.list  || !route.query.viewType" />
        <Calendar :filter="query" :status="appointmentStatus" v-if="route.query.viewType === modelViewType.calendar" />
      </template>
    </SubLayout>
</template>

<script setup>

import {computed, nextTick, onMounted, onUpdated, ref, watch} from "vue";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import ActionsBar from "@/Modules/CRM/views/Appointment/components/ActionsBar.vue";
import List from "./components/List.vue"
import {useModelViewType} from "@/composables/modelViewType";
import Calendar from "./components/Calendar.vue"

const store = useStore()
const route = useRoute()
const { modelViewType } = useModelViewType()

const title = ref("menu.crm.appointments")
const breadcrumbs = ref([
  {
    name: 'appointments.list',
    route: 'appointments'
  }
])

const query = ref({
  status: 'all',
  type: 'all',
  start_date: '',
  end_date: '',
  search: '',
  rdv_created: true,
  rdv_guested: true
})

const types = computed(() => store.getters['appointmentTypes/getAppointmentTypes'])
const appointmentStatus = computed(() => store.getters['appointments/appointmentStatus'])

function handleRangeDate (range) {
  query.value.start_date = range.start_date
  query.value.end_date = range.end_date
}

function loadData() {
  Promise.all([
    store.dispatch('crmPayments/loadPaymentStatus'),
    store.dispatch('appointmentTypes/loadAppointmentTypes'),
    store.dispatch('appointments/loadAppointmentStatus')
  ])
}

onMounted( () => {
  loadData()
})


</script>